/** Validate transport at each trusted configuration boundary. Preserve the
 * supplied mount path/suffix; consumers normalize API suffixes separately. */
export function validateGatewayBaseUrl(value: string, allowLocalHttp = false): string {
  const fail = (reason: string): never => { throw new Error(`VELUGA_GATEWAY_BASE_URL: ${reason}`); };
  if (!value || /\s/.test(value) || value.includes('\\')) fail('invalid URL syntax');
  let url: URL;
  try { url = new URL(value); } catch { return fail('invalid URL syntax'); }
  if (url.username || url.password || value.includes('@')) fail('userinfo is forbidden');
  if (value.includes('?') || value.includes('#')) fail('query and fragment are forbidden');
  if (url.protocol !== 'https:') {
    if (url.protocol !== 'http:' || !allowLocalHttp || !['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)) {
      fail('HTTPS is required except for explicitly enabled local loopback HTTP');
    }
  }
  if (!/^https?:\/\/[^/]/i.test(value) || !url.hostname) fail('invalid URL syntax');
  return value;
}
